export const ACCOUNT_STATEMENTS = gql`
    query GetAccountStatements {
        getAccountStatements {
            id
            accountStatementId
            startDateTime
            endDateTime
            statementDate
            createdAt
            outstandingBalance
            merchant {
                tradingName
                accountNumber
            }
        }
    }
`;
